<template>
  <div
    data-testid="dot-loader"
    class="dot-pulse"
  >
    <div
      class="dot-pulse__item"
      :class="`dot-pulse__item--${size}`"
    />
    <div
      class="dot-pulse__item"
      :class="`dot-pulse__item--${size}`"
    />
    <div
      class="dot-pulse__item"
      :class="`dot-pulse__item--${size}`"
    />
  </div>
</template>

<script>
const VALID_SIZES = ['sm', 'md']

export default {
  props: {
    size: {
      type: String,
      default: 'md',
      validator: size => VALID_SIZES.includes(size)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@ui/styles/src/scss/utils/lib";

.dot-pulse {
  display: flex;
  justify-content: center;
  padding: 1rem 0;

  &.grey .dot-pulse__item {
    background-color: $grey-50 !important;
  }

  &__item {
    display: inline-block;
    background-color: $primaryColor;
    border-radius: 100%;

    &:nth-child(1) {
      animation: 0.75s pulsate 0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
    }

    &:nth-child(2) {
      animation: 0.75s pulsate 0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
    }

    &:nth-child(3) {
      animation: 0.75s pulsate 0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);
    }
  }

  &__item--sm {
    width: 4px;
    height: 4px;
    margin: 3px;
  }

  &__item--md {
    width: 6px;
    height: 6px;
    margin: 4px;
  }
}

@keyframes pulsate {
  0%,
  80% {
    transform: scale3d(1, 1, 1);
    opacity: 1;
  }

  45% {
    transform: scale3d(0.1, 0.1, 1);
    opacity: 0.7;
  }
}
</style>
